import { Config } from "../../../configurations/config";
export const ProjectReport_API = {
	//------------------------ Offsite Work Hours Listing Screen API -----------------------//

	GetEmployeeList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
	GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
	GetSupervisorList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsList`,
	GetProjectList: `${Config.server_url}${Config.api_prefix}/Project/GetAllProjectsList`,
	GetProjectReportData: `${Config.server_url}${Config.api_prefix}/Project/ProjectReport?`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/Project/ProjectReport/ExportToExcel`,
};
